import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow , TableSortLabel, Button} from '@mui/material';
import React from 'react';
import { logToDatadog } from 'services/datadog';
import IssueDetailsModal from './IssueDetail';
import LoadingTableRow from './LoadingTableRow';

const AssetOverviewTable = ({
  isLoading,
  issues,
  closeIssue,
  onRequestSort
}) => {
  
  const [selectedIssue, setSelectedIssue] = React.useState(null);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const handleIssueClick = (issue) => {
      setSelectedIssue(issue);
      setIsModalOpen(true);
  };
  const handleCloseModal = () => {
      setIsModalOpen(false);
  };
  const closeIssueCall = (note, issueId) => {
    closeIssue(note,issueId);
    handleCloseModal();
  };
  const openInWrikeCall = async (issue) => {
    try {
      const response = await fetch(
        'https://hooks.zapier.com/hooks/catch/5991363/2yw7wq3',
        {
          method: 'POST',
          body: JSON.stringify({
            "reporter": issue.openedByUser,
            "raiser": issue.openedByUser,
            "assetId": issue.assetName,
            "issueTitle": issue.title,
            "issueDescription": issue.note,
            "urgency": issue.severity,
            "category": issue.issueCategory,
            "fixesTried": issue.detail,
            "location": issue.location,
            "slackLink": issue.slackMessageWeblink
          })
        }
      );

      if (response.ok) {
        alert('Successfully opened issue in wrike');
      } else {
        logToDatadog('error_open_in_wrike', {response}, 'error');
        alert('Failed to open issue in wrike');
      }
    } catch (error) {
      logToDatadog('error_open_in_wrike', {error}, 'error');
      alert('Failed to open issue in wrike');
    }
  }
  const lookup = new Map<string, string>();
  lookup.set('DR', 'DR_TESTING');
  lookup.set('BL', 'BLANCH');
  lookup.set('MR', '383_TESTING');
  lookup.set("EO", "ESPOO");
  lookup.set('PS', 'PECAN_SQUARE');
  const [sortBy, setSortBy] = React.useState('lastCheck');
  const [order, setOrder] = React.useState<'desc' | 'asc'>('desc');
  const createSortHandler =
    (property: string) => (event: React.MouseEvent<unknown>) => {
      if (property === sortBy) {
        setOrder(order === 'asc' ? 'desc' : 'asc');
      } else {
        setOrder('desc')
      }
      setSortBy(property)
      onRequestSort(event, property, order);
    };

  return (
    <div>
      <TableContainer component={Paper}>
    <Table sx={{ minWidth: 650 }} aria-label="assets table">
      <TableHead>
        <TableRow>
        <TableCell sx={{ width: '200px' }}>
            <TableSortLabel
              active={sortBy === 'title'}
              direction={order}
              onClick={createSortHandler('title')}
            >
              Title
            </TableSortLabel>
          </TableCell>
          <TableCell>
            <TableSortLabel
              active={sortBy === 'location'}
              direction={order}
              onClick={createSortHandler('location')}
            >
              Location
            </TableSortLabel>
          </TableCell>
          <TableCell>
            <TableSortLabel
              active={sortBy === 'severity'}
              direction={order}
              onClick={createSortHandler('severity')}
            >
              Severity
            </TableSortLabel>
          </TableCell>
          <TableCell>
            <TableSortLabel
              active={sortBy === 'assetName'}
              direction={order}
              onClick={createSortHandler('assetName')}
            >
              Asset Name
            </TableSortLabel>
          </TableCell>
          <TableCell>
            <TableSortLabel
              active={sortBy === 'assetType'}
              direction={order}
              onClick={createSortHandler('assetType')}
            >
              Asset Type
            </TableSortLabel>
          </TableCell>
          <TableCell>
            <TableSortLabel
              active={sortBy === 'created'}
              direction={order}
              onClick={createSortHandler('created')}
            >
              Opened On
            </TableSortLabel>
          </TableCell>
          <TableCell>
            <TableSortLabel
              active={sortBy === 'openedByUser'}
              direction={order}
              onClick={createSortHandler('openedByUser')}
            >
              Opened By
            </TableSortLabel>
          </TableCell>
          <TableCell>
            <TableSortLabel
              active={sortBy === 'issueState'}
              direction={order}
              onClick={createSortHandler('issueState')}
            >
              State
            </TableSortLabel>
          </TableCell>
          <TableCell>
            <TableSortLabel
              active={sortBy === 'issueCategory'}
              direction={order}
              onClick={createSortHandler('issueCategory')}
            >
              Type
            </TableSortLabel>
          </TableCell>
          <TableCell>
            <TableSortLabel
              active={sortBy === 'issueSubCategory'}
              direction={order}
              onClick={createSortHandler('issueSubCategory')}
            >
              Category
            </TableSortLabel>
          </TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {isLoading ? <LoadingTableRow /> : <></>}
        {!isLoading && issues.map((issue) => (
          <TableRow
            key={issue.id}
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
          >
            <TableCell>
              <p>{issue.title}</p>
            </TableCell>
            <TableCell>
              <p>{lookup.get(issue.location)}</p>
            </TableCell>
            <TableCell>
              <p>{issue.severity}</p>
            </TableCell>
            <TableCell>
              <p>{issue.assetName}</p>
            </TableCell>
            <TableCell>
              <p>{issue.assetType}</p>
            </TableCell>
            <TableCell component="th" scope="row">
            <p>{new Date(issue.created).toLocaleString(['en-IE', 'en-GB'])}</p>
            </TableCell>
            <TableCell>
              <p>{issue.openedByUser}</p>
            </TableCell>
            <TableCell>
              <p>{issue.issueState}</p>
            </TableCell>
            <TableCell>
            <p>{issue.issueCategory}</p>
            </TableCell>
            <TableCell>
            <p>{issue.issueSubCategory}</p>
            </TableCell>
            <TableCell>
            <Button color="primary" variant="contained" onClick={() => handleIssueClick(issue)}>VIEW ISSUE</Button>
            </TableCell>
        </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
  <IssueDetailsModal
    issue={selectedIssue}
    isOpen={isModalOpen}
    onClose={handleCloseModal}
    closeIssue={closeIssueCall}
    openInWrike={openInWrikeCall}
  />
    </div>
  );
};

export default AssetOverviewTable;

